module.exports = __webpack_public_path__ + "media/images/icons/time-black-3d76bec67af6768dd5abe8142b2bc1e6.svg";